export enum Role {
  Care_Giver = 'CareGiver',
  Care_Recipient = 'CareRecipient',
  Health_Care_Provider = 'HealthCareProvider'
}
